import { render, staticRenderFns } from "./medico.vue?vue&type=template&id=2a0d354d&"
import script from "./medico.vue?vue&type=script&lang=js&"
export * from "./medico.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports